import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{faqData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{faqData.subtitle}</p>
        </div>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqData.items.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                <span className="text-primary-500 mr-2 font-extrabold">Q:</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed pl-7">
                <span className="text-foreground-400 font-extrabold mr-2">A:</span>
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}